import { apiGet, apiSend } from './httpClient'
import type { AutoAlbumsResult } from './types'

export function getAutoAlbums(tripId: string): Promise<AutoAlbumsResult> {
  return apiGet<AutoAlbumsResult>(`/trips/${tripId}/albums/auto`)
}

export function applyAlbumPicks(tripId: string, mediaIds: string[]): Promise<{ updated: number }> {
  return apiSend<{ updated: number }>('POST', `/trips/${tripId}/albums/apply`, { media_ids: mediaIds })
}
